uniform sampler2D uDiffuseMap;
uniform vec3 hologramColor;
uniform float time;
uniform float uOpacity;
uniform float scanLineFrequency;
uniform float scanLineSpeed;
uniform float distortionAmount;
uniform float glowAmount;
uniform float flickerSpeed;
uniform float flickerIntensity;
uniform float textureInfluence;
uniform float effectsIntensity;
uniform float positionScale;
uniform float uFadeHeight;
uniform float uTerrainHeight;
uniform float uBrightness;


varying vec2 vUv;
varying vec3 vPosition;
varying vec3 vWorldPosition;
varying vec3 vNormalVector;

// Random noise function
float random(vec2 co) {
  return fract(sin(dot(co.xy, vec2(12.9898, 78.233))) * 43758.5453);
}

void main() {

    vec3 finalColor;
    float holoAlpha;
    vec2 effectCoords;

    // For effectsIntensity = 0, just show the original texture with full opacity

    if (effectsIntensity < 0.001) {
        vec4 originalTexture = texture2D(uDiffuseMap, vUv);
        //gl_FragColor = originalTexture;
        //csm_DiffuseColor = originalTexture;
        //csm_DiffuseColor = vec4(originalTexture.rgb, 1.0);
        finalColor = originalTexture.rgb;
        holoAlpha = 1.0;

    }else{

        // Using position for effects - normalize and scale
        // Choose any two axes that work best for your model
        effectCoords = vec2(vPosition.x * positionScale, vPosition.y * positionScale);


        // Apply time-based distortion to texture coordinates
        float distortionEffect = sin(effectCoords.y * 10.0 + time) * distortionAmount * 0.1 * effectsIntensity;
        vec2 distortedCoords = vUv + distortionEffect;

        vec4 texColor = texture2D(uDiffuseMap, distortedCoords);

        // Base color with rim lighting effect
        float rimLight = pow(1.0 - abs(dot(normalize(vNormalVector), vec3(0.0, 0.0, 1.0))), 2.0);
        vec3 baseColor = hologramColor * (rimLight * glowAmount + 0.5);

        // Blend texture with hologram color based on textureInfluence
        baseColor = mix(baseColor, texColor.rgb * hologramColor, textureInfluence);

        // Scanlines - use position or UV
        float scanY = effectCoords.y;
        float scanLine = sin(scanY * scanLineFrequency + time * scanLineSpeed) * 0.5 + 0.5;
        scanLine = pow(scanLine, 0.5);
        scanLine = mix(1.0, scanLine, effectsIntensity);

        // Flickering effect
        float flicker = 1.0 - (random(vec2(time * flickerSpeed, time * flickerSpeed)) * flickerIntensity * effectsIntensity);

        // Horizontal glitch lines
        float glitchY = effectCoords.y;
        float glitchLine = step(0.98, random(vec2(floor(glitchY * 20.0), time * 0.1))) * effectsIntensity;

        // Combine effects
        finalColor = baseColor * scanLine * flicker;
        finalColor += glitchLine * hologramColor * effectsIntensity;

        // Apply distortion to color
        finalColor += sin(time * 2.0 + scanY * 10.0) * distortionAmount * hologramColor * effectsIntensity;

        // Calculate alpha - blend between full opacity and hologram effect based on effectsIntensity
        holoAlpha = uOpacity * scanLine * flicker;

        // Optional: Use texture alpha if available
        if (texColor.a < 1.0) {
            holoAlpha *= texColor.a;
        }
    }

    // Compute the fade effect
    float fadeFactor = smoothstep(uTerrainHeight, uTerrainHeight + uFadeHeight, vWorldPosition.y);

    // Ensure the fade effect remains strong even with envMap blending
    finalColor.rgb *= fadeFactor;

    //add brightness
    finalColor.rgb *= uBrightness;

    // Final output with transparency
    csm_DiffuseColor = vec4(finalColor, holoAlpha);
    //gl_FragColor = vec4(finalColor, holoAlpha);
}